import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TaskAssigneePopoverComponent } from '../task-assignee-popover/task-assignee-popover.component';
import { TaskAssignee, Task } from '../../taskbook.types';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'multi-task-assignee-selector',
    templateUrl: './multi-task-assignee-selector.component.html',
    styleUrls: ['./multi-task-assignee-selector.component.scss', './../../taskbook-triage-actions/taskbook-triage-actions.component.scss', './../../task/task.component.scss', './../../../taskbook-backlog/task-detail-actions/task-detail-actions.component.scss'],
    standalone: true,
    imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    TaskAssigneePopoverComponent,
    MatTooltip
]
})
export class MultiTaskAssigneePopoverSelectorComponent implements OnChanges{

    assignees: TaskAssignee[] = [];
    disableSelection = false;
    availableManagers: TaskAssignee[] = [];
    availableManagersCtrl = new FormControl<TaskAssignee[]>([], [Validators.required, Validators.minLength(1)])

    @Input() selectedAssignees: TaskAssignee[];
    @Input() selectedItems: Task[];
    @Input() managers: TaskAssignee[];
    @Input() context: 'taskDetails' | 'backlogList';
    @Output() assigneesChange = new EventEmitter<TaskAssignee[]>();
  
    protected isPopoverOpen = false;

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
      if(changes.selectedAssignees){
        this.availableManagers = this.managers;
        this.selectedAssignees = changes.selectedAssignees.currentValue;
        this.assignees = this.selectedAssignees ? this.selectedAssignees : [];
        const assigneesIds = this.assignees.map(assignee => assignee.id);
        this.availableManagers = (this.context === 'taskDetails' && this.selectedAssignees.length !== 0) ?  this.managers.filter(manager => !assigneesIds.includes(manager.id)): this.managers;
        if (this.availableManagers.length === 0) {
          this.isPopoverOpen = false;
        }
        this.disableSelection = this.context === 'backlogList' ? (this.selectedItems.length === 0 || this.managers.length === 0) : this.availableManagers.length === 0;
        this.availableManagersCtrl.setValue(this.availableManagers)
      }
    }

    onAssigneeSelectionChanged(assignees: TaskAssignee[]) {
      this.assignees = assignees;
      this.assigneesChange.emit(this.assignees);
    }

    togglePopover(): void {
      this.isPopoverOpen = !this.isPopoverOpen;
    }

    onApply(selectedAssignees: TaskAssignee[]) {
      this.assignees = selectedAssignees;
      this.assigneesChange.emit(this.assignees);
      this.isPopoverOpen = false;
      this.selectedAssignees = [];
    }

  }
